// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl: 'http://51.178.43.143:8080/hospital/',  
  // apiUrl : 'http://51.178.43.143:8080/hospital-staging/',
  // apiUrl : 'http://api-sygmedic.madgi.ci/hospital-staging/',
  // apiUrl : 'https://api-sygmedic.madgi.ci/hospital/',
  apiUrl : 'https://api-sygmedic.madgi.ci/hospital-staging/',
  // apiUrl : 'http://31.220.93.164:8080/hospital-staging/',  
  // apiUrl : 'http://173.212.223.207:8080/hospital/',  
  // apiUrl : 'https://api-sygmedic.madgi.ci/hospital/',  
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
 